import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    height:${({ height }) => height ? height : '50px'};
    width:${({ width }) => width ? width : '50px'};
    min-height:${({ height }) => height ? height : '50px'};
    min-width:${({ width }) => width ? width : '50px'};
    /* border-radius:${({ borderRadius }) => borderRadius ? borderRadius : '50%'}; */
    border-radius: 100%;
    font-size:${({ fontSize }) => fontSize ? fontSize : '1.5rem'};
    font-weight:bolder;
    color: #ffffff;
    background-color:#1D86FF;
    justify-content: center;
    align-items: center;
`;


